// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input {
    border-radius: 28px;
    border: 1px solid #ccc;
    height: 35px;
    border-radius: 18px !important;
}

.blue-header {
    background: #00a6c6;
    padding: 10px 17px;
    color: #fff;
}

.business-details .single-detail {
    padding: 10px 15px;
    /*    border: 1px solid #d3d3d3;*/
    border-top: none;
    border-bottom: none;
}

.table>tbody>tr>td, .table>tbody>tr>th, .table>tfoot>tr>td, .table>tfoot>tr>th, .table>thead>tr>td, .table>thead>tr>th {
    vertical-align: middle;
}

#recent-reports {
    table-layout: fixed;
    width: 100%
}

#recent-reports th:first-child {
    width: 150px;
}

#recent-reports th:nth-child(2) {
    width: 180px;
}

#recent-reports th:nth-child(3) {
    width: 235px;
}

#recent-reports th:nth-child(4) {
    width: 235px;
}

#recent-reports th:nth-child(5) {
    width: 180px;
}

#recent-reports th:nth-child(6) {
    width: 200px;
}

#recent-reports th:last-child {
    width: 70px;
}

#recent-reports tbody tr.report-plan-a {
    background: #f5f5f5;
}

.report-plan-arrow {
    border-radius: 50%;
    height: 30px;
    width: 30px;
    text-align: center;
    padding: 6px 9px;
    border: 1px solid;
}

.padding0 {
    padding: 0px;
}

.rounded-num {
    background: #0575b5;
    padding: 3px 5px;
    color: #fff;
    border-radius: 50%;
    width: 25px;
    height: 25px;
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    margin-right: 2px;
}

.report-action-btn span {
    padding: 4px;
    color: #fff;
    border-radius: 50%;
    font-size: 12px;
    cursor: pointer;
}

.report-plan-arrow {
    border-color: #00a6c6;
    color: #00a6c6;
}

.text-wrap {
    white-space: nowrap;
    width: 31em;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    vertical-align: middle;
}

.text-wrap1 {
    white-space: nowrap;
    width: 7em;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    vertical-align: middle;
}

.pdficon img {
    width: 24px;
    margin-top: -4px;
}

.pdficon {
    background: none !important;
    padding: 0 !important;
}

.xlsicon img {
    width: 15px !important;
}

img {
    vertical-align: top;
}

tr th {
    background: #0075BB;
    color: #fff;
}

tr th:first-child {
    border-radius: 14px 0 0 0;
}

tr th:last-child {
    border-radius: 0 14px 0 0;
}

.card-content {
    margin-top: -66px;
    float: left;
    width: 100%;
}

.report-scenario table {
    border: none;
}

.InnerDivContentClass {
    width: 100%;
    display: block;
    padding: 10px;
}

.InnerDivContentClass label {
    width: 20%;
    margin: 5px 0;
    float: left;
}

.InnerDivContentClass input {
    width: 79%;
    margin: 5px 0;
    border-radius: 15px;
    border: 1px solid #999;
    padding: 6px 12px;
}

.InnerDivContentClass button {
    margin: auto;
    display: block;
    border-radius: 15px;
    padding: 4px 40px;
    background: #337ab7;
    color: #fff;
}

#menu1 {
    margin-left: 10px;
    border-radius: 50%;
    background: #fff;
    color: #333;
    border: 1px #dcdcdc solid;
    padding: 0px;
    width: 36px;
    height: 37px;
    position: absolute;
}

.open>.dropdown-menu {
    z-index: 2;
}

.fadeBackgroundActiveModelClass {
    background: #000;
    opacity: 0.5;
    position: absolute;
    width: 100%;
    height: 100%;
}

.displayNone {
    display: none;
}

.displayShow {
    display: block;
}

.searchClassDiv.addon-md .glyphicon-search, .searchClassDiv .glyphicon-search, .searchClassDiv.addon-md .fa, .searchClassDiv .fa {
    position: absolute;
    z-index: 2;
    font-size: 14px;
    width: 20px;
    margin-left: -32.5px;
    text-align: center;
    padding: 10px 0;
    top: 1px;
    float: right;
}

@media screen and (max-width:1024px) {
    #form, .open>.dropdown-menu {
        width: 90%;
    }
}

@media screen and (max-width:480px) {
    #form, .open>.dropdown-menu {
        width: 80%;
    }
}

.srch {
    display: block;
    border-radius: 15px;
    padding: 4px 20px;
    background: #337ab7;
    color: #fff;
    float: right;
}

body {
    padding-top: 50px;
}

.dropdown.dropdown-lg .dropdown-menu {
    margin-top: -1px;
    padding: 20px 20px;
    width: 100%;
}

.input-group-btn .btn-group {
    display: flex !important;
}

.btn-group .btn {
    margin-left: -1px;
    position: relative;
    left: 38px;
    border: 1px solid #ccc;
    border-radius: 50%;
    background: #fff;
    z-index: 9
}

.btn-group .btn:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}

.btn-group .form-horizontal .btn[type="submit"] {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}

.form-horizontal .form-group {
    margin-left: 0;
    margin-right: 0;
}

.form-group .form-control:last-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}

.dropdown {
    position: static !important;
}

#adv-search {
    position: relative;
    top: -91px;
    left: 53%;
}

@media screen and (min-width: 768px) {
    #adv-search {
        margin: 0 auto;
        margin-bottom: 60px;
    }
    .dropdown.dropdown-lg {
        position: static !important;
    }
    .dropdown.dropdown-lg .dropdown-menu {
        min-width: 500px;
    }
}

.report-action-btn {
    background: #509fcc;
    width: 151px;
    height: 28px;
    border-radius: 15px;
    text-align: center;
    float: left
}

.charticon {
    float: right;
    cursor: pointer;
}

.adminfrom .gj-datepicker {
    width: 66%;
}

.navbar-nav>li>a {
    padding-top: 0px;
    padding-bottom: 0px;
    padding-left: 0px;
    margin-left: -7px;
}

.nav>li>a>img {
    max-width: none;
    width: 27px;
    margin-right: 0px;
}

/*created by rahul nakra*/

.InnerDivContentClass label {
    width: 20%!important;
    margin: 10px 0 10px 0!important;
    float: left!important;
    font-weight: normal!important;
    font-size: 14px!important;
    padding-left: 10px!important;
}

.InnerDivContentClass input {
    border: 1px solid #cac5c5!important;
    width: 80%!important;
}

.InnerDivContentClass button {
    margin-top: 10px!important;
}

.table {
    border: 1px solid #0075BB;
    border-radius: 15px;
    float: left;
    max-width: 100%;
    border-collapse: inherit;
    background: #fff;
}


.glyphicon-search {
    position: absolute;
    z-index: 2;
    font-size: 14px;
    width: 20px;
    margin-left: -32.5px;
    text-align: center;
    padding: 10px 0;
    top: 1px;
    float: right;
}

#menu1 {
    margin-left: 10px;
    border-radius: 50%;
    background: #fff;
    color: #333;
    border: 1px #dcdcdc solid;
    padding: 0px;
    width: 36px;
    height: 37px;
    position: absolute;
    left: 96%;
}

#form {
    width: 95%;
    float: left;
    border-radius: 20px;
    height: 37px;
}

.addborder {
    border-radius: 16px;
    padding: 10px;
    right: 23px;
    top: 40px;
    height: 320px;
}

.ngx-datepicker-container .ngx-datepicker-input {
    padding: 6px 10px;
    font-size: 14px;
    width: 30% !important;
    outline: none;
    border: 1px solid #ccc !important;
    border-radius: 28px;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);
    float: left!important;
}

.ng-valid {
    width: 30%;
    float: left;
    margin-top: 6px;
}

.pagination>li>a, .pagination>li>span {
    border-radius: 50% !important;
    padding: 5px 0 0 0;
    height: 27px;
    width: 27px;
    text-align: center;
    margin: 5px 5px 0 0;
    font-size: 13px;
    border: none;
    color: #fff;
    background: #bcbec0;
}

.pagination {
    margin: 0;
    /* Added By Hari */
    width: 185px;
}

.sce-incompledted {
    background: #bcbec0;
    padding: 3px 5px;
    color: #fff;
    border-radius: 50%;
    width: 26px;
    height: 25px;
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    margin-right: 2px;
    position: relative;
}

.draft {
    background: #9A0A35;
}


.pagination {
    display: table-cell !important
}

.market-div {
    margin-top: 0px;
}

.btn-sm-rounded {
    vertical-align: top;
    margin-top: 6px;
}

.modal-body {
    position: relative;
    padding: 6px 16px;
}

.invite-user {
    margin-bottom: 5px;
    ;
}

.btn-cancel {
    margin-right: 5px !important;
}

.invite-user-action-div {
    display: flex;
    float: right;
    margin-top: 10px;
}


.InnerDivContentClass ng-multiselect-dropdown {
    border: 1px solid #cac5c5!important;
    width: 80%!important;
}

ng-multiselect-dropdown {
    border-radius: 28px;
    border: 1px solid #ccc;
    height: 35px;
    border-radius: 18px !important;
    width: 20% !important;
}

:host ::ng-deep .multi-select-market .multiselect-dropdown .dropdown-btn{
    border: none !important;
}

:host ::ng-deep .multi-select-market .multiselect-dropdown .dropdown-list{
    margin-top: 1px !important;
}

.InnerDivContentClass select{
    border: 1px solid #cac5c5!important;
    width: 80%!important;
}

select {
    border-radius: 28px;
    border: 1px solid #ccc;
    height: 35px;
    border-radius: 18px !important;
    width: 20% !important;
}

.market-filter{
    padding-left: 10px;
}

.search-by-user-email{
    width:40% !important;
    margin-top: 6px;
    margin-left: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/manage-users/manage-users.component.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,iCAAiC;IACjC,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,uBAAuB;IACvB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,WAAW;AACf;;AAEA;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,WAAW;IACX,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;IACf,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;AACb;;AAEA;IACI;QACI,cAAc;QACd,mBAAmB;IACvB;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,iBAAiB;AACrB;;AAEA,yBAAyB;;AAEzB;IACI,oBAAoB;IACpB,+BAA+B;IAC/B,qBAAqB;IACrB,6BAA6B;IAC7B,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,mCAAmC;IACnC,oBAAoB;AACxB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,wBAAwB;IACxB,gBAAgB;AACpB;;;AAGA;IACI,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,WAAW;IACX,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;IACf,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,qBAAqB;IACrB,aAAa;IACb,iCAAiC;IACjC,mBAAmB;IACnB,+CAA+C;IAC/C,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;;AAGA;IACI;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;;AAEtB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,gBAAgB;AACpB;;;AAGA;IACI,mCAAmC;IACnC,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,mCAAmC;IACnC,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;AACpB","sourcesContent":["input {\r\n    border-radius: 28px;\r\n    border: 1px solid #ccc;\r\n    height: 35px;\r\n    border-radius: 18px !important;\r\n}\r\n\r\n.blue-header {\r\n    background: #00a6c6;\r\n    padding: 10px 17px;\r\n    color: #fff;\r\n}\r\n\r\n.business-details .single-detail {\r\n    padding: 10px 15px;\r\n    /*    border: 1px solid #d3d3d3;*/\r\n    border-top: none;\r\n    border-bottom: none;\r\n}\r\n\r\n.table>tbody>tr>td, .table>tbody>tr>th, .table>tfoot>tr>td, .table>tfoot>tr>th, .table>thead>tr>td, .table>thead>tr>th {\r\n    vertical-align: middle;\r\n}\r\n\r\n#recent-reports {\r\n    table-layout: fixed;\r\n    width: 100%\r\n}\r\n\r\n#recent-reports th:first-child {\r\n    width: 150px;\r\n}\r\n\r\n#recent-reports th:nth-child(2) {\r\n    width: 180px;\r\n}\r\n\r\n#recent-reports th:nth-child(3) {\r\n    width: 235px;\r\n}\r\n\r\n#recent-reports th:nth-child(4) {\r\n    width: 235px;\r\n}\r\n\r\n#recent-reports th:nth-child(5) {\r\n    width: 180px;\r\n}\r\n\r\n#recent-reports th:nth-child(6) {\r\n    width: 200px;\r\n}\r\n\r\n#recent-reports th:last-child {\r\n    width: 70px;\r\n}\r\n\r\n#recent-reports tbody tr.report-plan-a {\r\n    background: #f5f5f5;\r\n}\r\n\r\n.report-plan-arrow {\r\n    border-radius: 50%;\r\n    height: 30px;\r\n    width: 30px;\r\n    text-align: center;\r\n    padding: 6px 9px;\r\n    border: 1px solid;\r\n}\r\n\r\n.padding0 {\r\n    padding: 0px;\r\n}\r\n\r\n.rounded-num {\r\n    background: #0575b5;\r\n    padding: 3px 5px;\r\n    color: #fff;\r\n    border-radius: 50%;\r\n    width: 25px;\r\n    height: 25px;\r\n    display: inline-block;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n    margin-right: 2px;\r\n}\r\n\r\n.report-action-btn span {\r\n    padding: 4px;\r\n    color: #fff;\r\n    border-radius: 50%;\r\n    font-size: 12px;\r\n    cursor: pointer;\r\n}\r\n\r\n.report-plan-arrow {\r\n    border-color: #00a6c6;\r\n    color: #00a6c6;\r\n}\r\n\r\n.text-wrap {\r\n    white-space: nowrap;\r\n    width: 31em;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    display: inline-block;\r\n    vertical-align: middle;\r\n}\r\n\r\n.text-wrap1 {\r\n    white-space: nowrap;\r\n    width: 7em;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    display: inline-block;\r\n    vertical-align: middle;\r\n}\r\n\r\n.pdficon img {\r\n    width: 24px;\r\n    margin-top: -4px;\r\n}\r\n\r\n.pdficon {\r\n    background: none !important;\r\n    padding: 0 !important;\r\n}\r\n\r\n.xlsicon img {\r\n    width: 15px !important;\r\n}\r\n\r\nimg {\r\n    vertical-align: top;\r\n}\r\n\r\ntr th {\r\n    background: #0075BB;\r\n    color: #fff;\r\n}\r\n\r\ntr th:first-child {\r\n    border-radius: 14px 0 0 0;\r\n}\r\n\r\ntr th:last-child {\r\n    border-radius: 0 14px 0 0;\r\n}\r\n\r\n.card-content {\r\n    margin-top: -66px;\r\n    float: left;\r\n    width: 100%;\r\n}\r\n\r\n.report-scenario table {\r\n    border: none;\r\n}\r\n\r\n.InnerDivContentClass {\r\n    width: 100%;\r\n    display: block;\r\n    padding: 10px;\r\n}\r\n\r\n.InnerDivContentClass label {\r\n    width: 20%;\r\n    margin: 5px 0;\r\n    float: left;\r\n}\r\n\r\n.InnerDivContentClass input {\r\n    width: 79%;\r\n    margin: 5px 0;\r\n    border-radius: 15px;\r\n    border: 1px solid #999;\r\n    padding: 6px 12px;\r\n}\r\n\r\n.InnerDivContentClass button {\r\n    margin: auto;\r\n    display: block;\r\n    border-radius: 15px;\r\n    padding: 4px 40px;\r\n    background: #337ab7;\r\n    color: #fff;\r\n}\r\n\r\n#menu1 {\r\n    margin-left: 10px;\r\n    border-radius: 50%;\r\n    background: #fff;\r\n    color: #333;\r\n    border: 1px #dcdcdc solid;\r\n    padding: 0px;\r\n    width: 36px;\r\n    height: 37px;\r\n    position: absolute;\r\n}\r\n\r\n.open>.dropdown-menu {\r\n    z-index: 2;\r\n}\r\n\r\n.fadeBackgroundActiveModelClass {\r\n    background: #000;\r\n    opacity: 0.5;\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n.displayNone {\r\n    display: none;\r\n}\r\n\r\n.displayShow {\r\n    display: block;\r\n}\r\n\r\n.searchClassDiv.addon-md .glyphicon-search, .searchClassDiv .glyphicon-search, .searchClassDiv.addon-md .fa, .searchClassDiv .fa {\r\n    position: absolute;\r\n    z-index: 2;\r\n    font-size: 14px;\r\n    width: 20px;\r\n    margin-left: -32.5px;\r\n    text-align: center;\r\n    padding: 10px 0;\r\n    top: 1px;\r\n    float: right;\r\n}\r\n\r\n@media screen and (max-width:1024px) {\r\n    #form, .open>.dropdown-menu {\r\n        width: 90%;\r\n    }\r\n}\r\n\r\n@media screen and (max-width:480px) {\r\n    #form, .open>.dropdown-menu {\r\n        width: 80%;\r\n    }\r\n}\r\n\r\n.srch {\r\n    display: block;\r\n    border-radius: 15px;\r\n    padding: 4px 20px;\r\n    background: #337ab7;\r\n    color: #fff;\r\n    float: right;\r\n}\r\n\r\nbody {\r\n    padding-top: 50px;\r\n}\r\n\r\n.dropdown.dropdown-lg .dropdown-menu {\r\n    margin-top: -1px;\r\n    padding: 20px 20px;\r\n    width: 100%;\r\n}\r\n\r\n.input-group-btn .btn-group {\r\n    display: flex !important;\r\n}\r\n\r\n.btn-group .btn {\r\n    margin-left: -1px;\r\n    position: relative;\r\n    left: 38px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 50%;\r\n    background: #fff;\r\n    z-index: 9\r\n}\r\n\r\n.btn-group .btn:last-child {\r\n    border-top-right-radius: 4px;\r\n    border-bottom-right-radius: 4px;\r\n}\r\n\r\n.btn-group .form-horizontal .btn[type=\"submit\"] {\r\n    border-top-left-radius: 4px;\r\n    border-bottom-left-radius: 4px;\r\n}\r\n\r\n.form-horizontal .form-group {\r\n    margin-left: 0;\r\n    margin-right: 0;\r\n}\r\n\r\n.form-group .form-control:last-child {\r\n    border-top-left-radius: 4px;\r\n    border-bottom-left-radius: 4px;\r\n}\r\n\r\n.dropdown {\r\n    position: static !important;\r\n}\r\n\r\n#adv-search {\r\n    position: relative;\r\n    top: -91px;\r\n    left: 53%;\r\n}\r\n\r\n@media screen and (min-width: 768px) {\r\n    #adv-search {\r\n        margin: 0 auto;\r\n        margin-bottom: 60px;\r\n    }\r\n    .dropdown.dropdown-lg {\r\n        position: static !important;\r\n    }\r\n    .dropdown.dropdown-lg .dropdown-menu {\r\n        min-width: 500px;\r\n    }\r\n}\r\n\r\n.report-action-btn {\r\n    background: #509fcc;\r\n    width: 151px;\r\n    height: 28px;\r\n    border-radius: 15px;\r\n    text-align: center;\r\n    float: left\r\n}\r\n\r\n.charticon {\r\n    float: right;\r\n    cursor: pointer;\r\n}\r\n\r\n.adminfrom .gj-datepicker {\r\n    width: 66%;\r\n}\r\n\r\n.navbar-nav>li>a {\r\n    padding-top: 0px;\r\n    padding-bottom: 0px;\r\n    padding-left: 0px;\r\n    margin-left: -7px;\r\n}\r\n\r\n.nav>li>a>img {\r\n    max-width: none;\r\n    width: 27px;\r\n    margin-right: 0px;\r\n}\r\n\r\n/*created by rahul nakra*/\r\n\r\n.InnerDivContentClass label {\r\n    width: 20%!important;\r\n    margin: 10px 0 10px 0!important;\r\n    float: left!important;\r\n    font-weight: normal!important;\r\n    font-size: 14px!important;\r\n    padding-left: 10px!important;\r\n}\r\n\r\n.InnerDivContentClass input {\r\n    border: 1px solid #cac5c5!important;\r\n    width: 80%!important;\r\n}\r\n\r\n.InnerDivContentClass button {\r\n    margin-top: 10px!important;\r\n}\r\n\r\n.table {\r\n    border: 1px solid #0075BB;\r\n    border-radius: 15px;\r\n    float: left;\r\n    max-width: 100%;\r\n    border-collapse: inherit;\r\n    background: #fff;\r\n}\r\n\r\n\r\n.glyphicon-search {\r\n    position: absolute;\r\n    z-index: 2;\r\n    font-size: 14px;\r\n    width: 20px;\r\n    margin-left: -32.5px;\r\n    text-align: center;\r\n    padding: 10px 0;\r\n    top: 1px;\r\n    float: right;\r\n}\r\n\r\n#menu1 {\r\n    margin-left: 10px;\r\n    border-radius: 50%;\r\n    background: #fff;\r\n    color: #333;\r\n    border: 1px #dcdcdc solid;\r\n    padding: 0px;\r\n    width: 36px;\r\n    height: 37px;\r\n    position: absolute;\r\n    left: 96%;\r\n}\r\n\r\n#form {\r\n    width: 95%;\r\n    float: left;\r\n    border-radius: 20px;\r\n    height: 37px;\r\n}\r\n\r\n.addborder {\r\n    border-radius: 16px;\r\n    padding: 10px;\r\n    right: 23px;\r\n    top: 40px;\r\n    height: 320px;\r\n}\r\n\r\n.ngx-datepicker-container .ngx-datepicker-input {\r\n    padding: 6px 10px;\r\n    font-size: 14px;\r\n    width: 30% !important;\r\n    outline: none;\r\n    border: 1px solid #ccc !important;\r\n    border-radius: 28px;\r\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);\r\n    float: left!important;\r\n}\r\n\r\n.ng-valid {\r\n    width: 30%;\r\n    float: left;\r\n    margin-top: 6px;\r\n}\r\n\r\n.pagination>li>a, .pagination>li>span {\r\n    border-radius: 50% !important;\r\n    padding: 5px 0 0 0;\r\n    height: 27px;\r\n    width: 27px;\r\n    text-align: center;\r\n    margin: 5px 5px 0 0;\r\n    font-size: 13px;\r\n    border: none;\r\n    color: #fff;\r\n    background: #bcbec0;\r\n}\r\n\r\n.pagination {\r\n    margin: 0;\r\n    /* Added By Hari */\r\n    width: 185px;\r\n}\r\n\r\n.sce-incompledted {\r\n    background: #bcbec0;\r\n    padding: 3px 5px;\r\n    color: #fff;\r\n    border-radius: 50%;\r\n    width: 26px;\r\n    height: 25px;\r\n    display: inline-block;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n    margin-right: 2px;\r\n    position: relative;\r\n}\r\n\r\n.draft {\r\n    background: #9A0A35;\r\n}\r\n\r\n\r\n.pagination {\r\n    display: table-cell !important\r\n}\r\n\r\n.market-div {\r\n    margin-top: 0px;\r\n}\r\n\r\n.btn-sm-rounded {\r\n    vertical-align: top;\r\n    margin-top: 6px;\r\n}\r\n\r\n.modal-body {\r\n    position: relative;\r\n    padding: 6px 16px;\r\n}\r\n\r\n.invite-user {\r\n    margin-bottom: 5px;\r\n    ;\r\n}\r\n\r\n.btn-cancel {\r\n    margin-right: 5px !important;\r\n}\r\n\r\n.invite-user-action-div {\r\n    display: flex;\r\n    float: right;\r\n    margin-top: 10px;\r\n}\r\n\r\n\r\n.InnerDivContentClass ng-multiselect-dropdown {\r\n    border: 1px solid #cac5c5!important;\r\n    width: 80%!important;\r\n}\r\n\r\nng-multiselect-dropdown {\r\n    border-radius: 28px;\r\n    border: 1px solid #ccc;\r\n    height: 35px;\r\n    border-radius: 18px !important;\r\n    width: 20% !important;\r\n}\r\n\r\n:host ::ng-deep .multi-select-market .multiselect-dropdown .dropdown-btn{\r\n    border: none !important;\r\n}\r\n\r\n:host ::ng-deep .multi-select-market .multiselect-dropdown .dropdown-list{\r\n    margin-top: 1px !important;\r\n}\r\n\r\n.InnerDivContentClass select{\r\n    border: 1px solid #cac5c5!important;\r\n    width: 80%!important;\r\n}\r\n\r\nselect {\r\n    border-radius: 28px;\r\n    border: 1px solid #ccc;\r\n    height: 35px;\r\n    border-radius: 18px !important;\r\n    width: 20% !important;\r\n}\r\n\r\n.market-filter{\r\n    padding-left: 10px;\r\n}\r\n\r\n.search-by-user-email{\r\n    width:40% !important;\r\n    margin-top: 6px;\r\n    margin-left: 5px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
